import * as DashboardArticles from './articles/dashboard';
import * as PublishArticles from './articles/publish';

export type HelpContent = {
  PRESSRELEASES: {
    header: string;
    description: string;
    hotjarTrigger: string;
    guides: {
      title: string;
      questions: {
        title: string;
        answer: JSX.Element;
      }[];
    }[];
  };
  DASHBOARD: {
    header: string;
    description: string;
    hotjarTrigger: string;
    guides: {
      title: string;
      questions: {
        title: string;
        answer: JSX.Element;
      }[];
    }[];
    externalLinks: {
      title: string;
      link: string;
    }[];
  };
};

const HELP_CONTENT: HelpContent = {
  PRESSRELEASES: {
    header: 'Publish',
    description:
      'In publish you manage all the content on your newsroom, be it stories or your public media library',
    hotjarTrigger: 'help_panel_start',
    guides: [
      {
        title: 'Creating a press release',
        questions: [
          {
            title: 'Picking the perfect cover photo',
            answer: <PublishArticles.CoverPhoto />,
          },
          {
            title: 'Related content',
            answer: <PublishArticles.RelatedContent />,
          },
          {
            title: 'Tags',
            answer: <PublishArticles.Tags />,
          },
        ],
      },
      {
        title: 'Distributing a press release',
        questions: [
          {
            title: 'Backdating a story',
            answer: <PublishArticles.BackdatingStory />,
          },
          {
            title: 'Who receives my content?',
            answer: <PublishArticles.WhoReceivesContent />,
          },
          {
            title: 'Selecting topics and regions',
            answer: <PublishArticles.SelectingTopicsAndRegions />,
          },
          {
            title: 'Email distribution',
            answer: <PublishArticles.EmailDistribution />,
          },
        ],
      },
    ],
  },
  DASHBOARD: {
    header: 'Dashboard',
    description:
      'The dashboard gives you basic statistics of your newsroom like views over the last 7 and 30 days, average time ' +
      'spent in your newsroom and your most popular stories. The map shows where your visitors come from. You can even ' +
      'zoom in to see exactly where. In the bottom, you can see your latest followers and the latest news from us at ' +
      'Mynewsdesk. ',
    hotjarTrigger: 'dashboard_help_panel_start',
    guides: [
      {
        title: 'Getting started',
        questions: [
          {
            title: 'Setting up your newsroom',
            answer: <DashboardArticles.SettingUpNewsroom />,
          },
          {
            title: 'The different parts of the product',
            answer: <DashboardArticles.ProductOverview />,
          },
          {
            title: 'Mynewsdesk Intro Course',
            answer: <DashboardArticles.IntroCourse />,
          },
          {
            title: 'Mynewsdesk Library',
            answer: <DashboardArticles.MndLibrary />,
          },
        ],
      },
    ],
    externalLinks: [
      {
        title: 'How to add a new user',
        link: 'https://help.mynewsdesk.com/en/faq/how-to-add-a-new-user/',
      },
      {
        title: 'What’s the difference between a contact and a press contact?',
        link: 'https://help.mynewsdesk.com/en/faq/whats-the-difference-between-a-contact-and-a-press-contact/',
      },
      {
        title: 'Press release, news and blog posts - what’s the difference?',
        link: 'https://help.mynewsdesk.com/en/faq/whats-the-difference-between-a-press-release-a-news-story-and-a-blog-post/',
      },
      {
        title: 'In what ways can I show my newsroom on my own website?',
        link: 'https://help.mynewsdesk.com/en/faq/show-newsroom-on-own-website/',
      },
      {
        title: 'Activate new newsroom design',
        link: 'https://help.mynewsdesk.com/en/how-to/new-newsroom-design/',
      },
      {
        title: 'How to enable and log in with two-factor authentication',
        link: 'https://help.mynewsdesk.com/en/how-to/how-to-enable-and-login-with-two-factor-authentication/',
      },
    ],
  },
};

export default HELP_CONTENT;
